import React, { useState } from "react";
import {
  Container,
  Box,
  TextField,
  Button,
  Paper,
  Typography,
  Link,
  Snackbar,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { useAuth } from "../context/AuthContext";

const Login = () => {
  const { login, forgotPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [forgotMode, setForgotMode] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };
  const handleSnackbarClose = () => setSnackbar(s => ({ ...s, open: false }));

  const handleLogin = async () => {
    try {
      await login(email, password);
    } catch (err) {
      showSnackbar(err.message || "Login failed", "error");
    }
  };

  const handleForgot = async () => {
    try {
      await forgotPassword(email);
      showSnackbar("If we know the email, we will send you a new password!", "success");
      setTimeout(() => setForgotMode(false), 2000)
    } catch (err) {
      showSnackbar(err.message || "Could not send reset email", "error");
    }
  };

  return (
    <Container maxWidth="xs">
      <Paper elevation={3} sx={{ p: 4, mt: 8, textAlign: "center", borderRadius: 2 }}>
        {/* Logo */}
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/logo.png`}
          alt="Logo"
          sx={{ width: 140, height: "auto", mx: "auto", mb: 3 }}
        />

        <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
          {forgotMode ? "Reset Password" : "Sign In"}
        </Typography>

        {/* Email */}
        <TextField
          fullWidth
          label="Email"
          variant="outlined"
          margin="dense"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />

        {/* Password only in login mode */}
        {!forgotMode && (
          <TextField
            fullWidth
            label="Password"
            type="password"
            variant="outlined"
            margin="dense"
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
        )}

        {/* Primary action */}
        <Button
          fullWidth
          variant="contained"
          color="primary"
          sx={{ mt: 3 }}
          onClick={forgotMode ? handleForgot : handleLogin}
        >
          {forgotMode ? "Reset password" : "Sign In"}
        </Button>

        {/* Toggle link */}
        <Box mt={2}>
          {forgotMode ? (
            <Link component="button" variant="body2" onClick={() => setForgotMode(false)}>
              Back to Sign In
            </Link>
          ) : (
            <Link component="button" variant="body2" onClick={() => setForgotMode(true)}>
              Forgot password?
            </Link>
          )}
        </Box>
      </Paper>

      {/* Feedback */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </MuiAlert>
      </Snackbar>
    </Container>
  );
};

export default Login;